/**
 * Blog tag nav: scroll the current tag into view.
 * Loaded from sections/blog-header.liquid as type="module".
 */

const SELECTOR = '[data-section-type="blog-header"]'

function init(root) {
  if (root.dataset.bhInit) return
  root.dataset.bhInit = 'true'

  const bar = root.querySelector('.js-blog-bar')
  const current = root.querySelector('.is-current')
  if (bar && current) {
    bar.scrollTo({ left: current.offsetLeft - bar.clientWidth / 2 + current.clientWidth / 2, behavior: 'smooth' })
  }
}

function initAll(scope = document) {
  if (scope.matches?.(SELECTOR)) init(scope)
  scope.querySelectorAll(SELECTOR).forEach(init)
}

initAll()
document.addEventListener('shopify:section:load', (event) => initAll(event.target))
